var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tabs)?_c('TabMenu',{attrs:{"model":_vm.tabs}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }